export enum RequestFormStatus {
    PRISTINE,
    DIRTY,
    READY_TO_SUBMIT,
    ERROR,
    LOADING,
    SUBMITTED
}
